<template>
  <div>
    <CommonHead></CommonHead>
    <div class="contactus">
      <b-jumbotron class="pl-0 pr-0 pt-0 pb-0 mb-0" container-fluid="true" bg-variant="white">
        <b-container fluid>
          <b-row>
            <b-col>
              <div class="contact">
                <h1 class="seo-purpose">Contact us</h1>
                <h2>Get in touch with us</h2>
                <p>We would like to hear from you. If you have any questions or comments regarding our site or company please complete the form below.</p>
                <p>Are you an RM COCO Account Holder?</p>
                <b-form class="commonform" @submit="onSubmit">
                <b-row>
                  <b-col>
                      <div class="commres">
                          <md-radio v-model="form.radio" name="yes" value="yes">Yes</md-radio>
                          <md-radio v-model="form.radio" name="no" value="no">No</md-radio>
                      </div>
                  </b-col>
                </b-row>
                <div class="nodiv" v-show="form.radio === 'no'">
                  <p>To open an account directly with RM COCO, please complete our <a class="request_form" href="/apply/">Request new account form.</a></p>
                  <hr>
                  <div class="associates">
                    <p>I need assistance with...</p>
                    <div class="radio_cont">
                        <md-radio v-model="form.radio_as1" name="radio_as1" value="Finding a retailer or showroom">Finding a retailer or showroom</md-radio>
                        <md-radio v-model="form.radio_as1" name="radio_as1" value="Our website">Our website</md-radio>
                        <md-radio v-model="form.radio_as1" name="radio_as1" value="Public relations or media">Public relations or media</md-radio>
                        <md-radio v-model="form.radio_as1" name="radio_as1" value="Another topic">Another topic</md-radio>
                    </div>
                  </div>
                </div>
                <div class="yesdiv" v-show="form.radio === 'yes'">
                  <p>For price and stock information, please <a class="request_form" href="/shop/login">Sign in</a> or call <a class="request_form" href="#">800.325.8025</a></p>
                  <hr>
                  <div class="associates">
                    <p>I need assistance with...</p>
                    <div class="radio_cont">
                        <md-radio v-model="form.radio_as" name="radio_as" value="Ordering samples">Ordering samples</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Ordering products">Ordering products</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Existing orders">Existing orders</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Updating account information">Updating account information</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Our website">Our website</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="RM COCO Furnishings">RM COCO Furnishings</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Permission to use photography">Permission to use photography</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Credit department">Credit department</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Research Department">Research Department</md-radio>
                        <md-radio v-model="form.radio_as" name="radio_as" value="Another Topic">Another Topic</md-radio>
                    </div>
                  </div>
                </div>
                <div class="cont_form">
                      <b-row>
                          <b-col>
                              <md-field :state="!form.errors.has('fullname')" :class="form.errors.get('fullname')?'forstar haserror':'forstar'"
                              :invalid-feedback="form.errors.get('fullname')">
                              <label>Full Name</label>
                              <md-input type="text" v-model="form.fullname" :state="!form.errors.has('fullname')" @input="form.errors.clear('fullname')"></md-input>
                              </md-field>
                          </b-col>
                          <b-col v-show="form.radio === 'yes'">
                              <md-field :state="!form.errors.has('accountnumber')" :class="form.errors.get('accountnumber')?'forstar haserror':'forstar'"
                              :invalid-feedback="form.errors.get('accountnumber')">
                              <label>Account Number</label>
                              <md-input type="text" v-model="form.accountnumber" :state="!form.errors.has('accountnumber')" @input="form.errors.clear('accountnumber')"></md-input>
                              </md-field>
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col>
                              <md-field :state="!form.errors.has('email')" :class="form.errors.get('email')?'forstar haserror':'forstar'"
                              :invalid-feedback="form.errors.get('email')">
                              <label>Email</label>
                              <md-input type="email" v-model="form.email" :state="!form.errors.has('email')" @input="form.errors.clear('email')"></md-input>
                              </md-field>
                          </b-col>
                          <b-col>
                              <md-field :state="!form.errors.has('phonenumber')" :class="form.errors.get('phonenumber')?'forstar haserror':'forstar'"
                              :invalid-feedback="form.errors.get('phonenumber')">
                              <label>Phone Number</label>
                              <md-input type="number" v-model="form.phonenumber" :state="!form.errors.has('phonenumber')" @input="form.errors.clear('phonenumber')"></md-input>
                              </md-field>
                          </b-col>
                      </b-row>
                      <b-row>
                          <b-col>
                              <md-field :state="!form.errors.has('questions')" :class="form.errors.get('questions')?'forstar haserror':'forstar'"
                              :invalid-feedback="form.errors.get('questions')">
                              <label>Questions or Comments</label>
                              <md-textarea v-model="form.questions" :state="!form.errors.has('questions')" @input="form.errors.clear('questions')"></md-textarea>
                              </md-field>
                          </b-col>
                      </b-row>
                      <b-button type="submit" block variant="dark">Submit</b-button>
                </div>
                </b-form>
              </div>
            </b-col>
            <b-col class="pr-0 pl-0 greyback" md="5" sm="12">
              <div class="right_cont">
                <h3>RM COCO</h3>
                <div class="comm-div">
                  <p>Phone 1 : 800.325.8025</p>
                  <p>Phone 2 : 573.334.0517</p>
                </div>
                <div class="comm-div">
                  <p>Fax 1 : 800.501.6810</p>
                  <p>Fax 2 : 573.334.7483</p>
                </div>
                <div class="comm-div">
                  <p>Hours : Monday – Friday</p>
                  <p>8 a.m. – 5:00 p.m. CDT</p>
                </div>
                <div class="comm-div">
                  <p>Email: <a href="#">customerservice@rmcoco.com</a></p>
                </div>
                <h3>Custom Creations</h3>
                <div class="comm-div">
                  <p>Phone 1 : 800.325.8025</p>
                  <p>Phone 2 : 573.334.0517</p>
                </div>
                <div class="comm-div">
                  <p>Fax 1 : 800.501.6810</p>
                  <p>Fax 2 : 573.334.7483</p>
                </div>
                <div class="comm-div">
                  <p>Hours : Monday – Friday</p>
                  <p>8 a.m. – 5:00 p.m. CDT</p>
                </div>
                <div class="comm-div">
                  <p>Email: <a href="#">customcreations@rmcoco.com</a></p>
                </div>
                <h3>RM COCO Corporate</h3>
                <div class="comm-div">
                  <p>1389 Southern Expressway<br>
                      P.O. Box 1270<br>
                      Cape Girardeau, MO 63702-1270<br>
                      573.334.0517</p>
                </div>
                <div class="comm-div">
                  <p>Email: <a href="#">customerservice@rmcoco.com</a></p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-jumbotron>
    </div>
    <CommonFoot></CommonFoot>
  </div>
</template>

<script>
import CommonHead from "@/components/CommonHead";
import CommonFoot from "@/components/CommonFoot";

export default {
    components: {
        CommonHead,
        CommonFoot
    },
    metaInfo: {
      title: 'RM COCO | Contact Us',
      meta: [{
          name: 'description',
          content: 'Questions or comments? We want to hear from you. Fill out our contact form or call 1-800-325-8025.'
      }],
    },
    data() {
        return {
            form: new Form({
                radio:'yes',
                radio_as:"Ordering samples",
                radio_as1:'Finding a retailer or showroom',
                fullname: null,
                email: null,
                accountnumber: null,
                phonenumber:null,
                questions:null
            }),
            isLoading: false,
            successMessage:''
        };
    },
    methods: {
        onSubmit(evt){
            evt.preventDefault();
            this.$store.dispatch("contactRequest", {
                form: this.form
            }).then(() => {
                this.$notify({
                    text: "Thanks for contacting us!",
                    type: "success"
                });
                this.form = new Form({
                  radio:'yes',
                  radio_as:"Ordering samples",
                  radio_as1:'Finding a retailer or showroom',
                  fullname: null,
                  email: null,
                  accountnumber: null,
                  phonenumber:null,
                  questions:null
              });
            }).catch(error => {
                if (this.form.hasErrors()) {
                    this.$notify({
                        text:"There is a validation error. Please correct the fields outlined in red and try again.",
                        type: "error"
                    });
                } else {
                    this.$notify({
                        text: "Something went wrong!",
                        type: "error"
                    });
                }
            });
        }
    }
};
</script>
<style>
.greyback{
  background:#ececec;
}
.contact{
  padding-right: 60px;
  padding-top: 40px;
  padding-bottom: 70px;
  box-sizing: border-box;
  max-width: 900px;
  float: left;
  margin-left: 250px;
}
.contact h1,.contact h2{
  text-align: left;
  margin-bottom: 15px;
      font-family: "Playfair Display", serif;
    line-height: 32px;
    font-size: 30px !important;
}
.contact h1.seo-purpose{
	display:none;
}
.contact p{
  margin-bottom: 20px;
}
.contact .commres {
    margin-bottom: 10px;
}
.contact hr{
  border-top: 1px solid #d2d2d2;
  margin: 0 0 20px 0;
}
.radio_cont .md-radio.md-theme-default{
  width: 100%;
  margin-bottom: 15px !important;
}
.cont_form .commonform .md-field{
  margin-bottom: 10px;
}
.contact .yesdiv p,.contact .nodiv p{
  color:#777777;
}
.contact a.request_form{
  color: #303030;
  text-decoration: none;
}
.contact a.request_form:hover{
  text-decoration: none;
}
.cont_form .btn.btn-dark{
  margin-top: 20px;
}
.right_cont {
    padding: 40px 0 0 90px;
    max-width: 390px;
    float: left;
    box-sizing: border-box;
}
.right_cont h3{
  text-align: left;
  margin-bottom: 5px;
}
.right_cont .comm-div{
  margin-bottom: 30px;
  display: inline-block;
  width: 100%;
}
.right_cont .comm-div p{
  float: left;
}
.right_cont .comm-div p a{
  color: #303030;
  text-decoration: none;
  font-weight: normal;
}
@media only screen and (max-width:1680px){
 .contact{margin-left:120px;}
}
@media only screen and (max-width:1440px){
 .contact{margin-left:100px;}
}
@media only screen and (max-width:1367px){
 .contact{margin-left:60px;}
}
@media only screen and (max-width: 1440px) and (min-width: 1280px) {
  .login .login-form {
    margin-right: 200px;
  }
}
@media only screen and (max-width:1024px) and (min-width:768px){
.contactus .row .col,.contactus .row .greyback{flex-basis:100%;flex:100%;max-width:100%;}
.contactus .row .col .contact{
	padding: 40px 5px 70px 5px;
    max-width: 730px;
    margin: 0 auto;
    float: none;
}
.contactus .row .greyback .right_cont {
    padding: 40px 20px 0 20px;
    max-width: 730px;
    float: none;
    box-sizing: border-box;
	margin: 0 auto;
}
.radio_cont .md-radio.md-theme-default{
	margin-right:0;
}
.right_cont .comm-div p{
	float:none;
	width:100%;
}
}
@media only screen and (max-width:767px){
.contactus .row .col,.contactus .row .greyback{flex-basis:100%;}
.contactus .row .col .contact{
	padding-right:0;
	margin:0;
}
.contactus .row .greyback .right_cont {
    padding: 40px 20px 0 20px;
    max-width: 100%;
    float: none;
    box-sizing: border-box;
}
.radio_cont .md-radio.md-theme-default{
	margin-right:0;
}
.right_cont .comm-div p{
	float:none;
	width:100%;
}
}
</style>